import EventBus from "@plugins/common/service/eventbus";

const studentToolTipEventBus = new EventBus();
export default studentToolTipEventBus;
